/**
 * Scroll direction class to body
 *
 * @link reference artic.edu
 *
 * @version 	2025.12.03
 * @name   		CSlice\JS\Scroll_Direction
 */

window.addEventListener('DOMContentLoaded', () => {
	const body = document.body;

	let lastScrollTop = 0;
	let ticking = false;

	function handleScroll() {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		const scrollDifference = Math.abs(scrollTop - lastScrollTop);

		// Only update if scroll difference is significant (prevents jitter)
		if (scrollDifference > 5) {
			if (scrollTop > lastScrollTop) {
				// Scrolling down
				body.classList.remove('cslice-scroll-direction-up');
				body.classList.add('cslice-scroll-direction-down');
			} else {
				// Scrolling up
				body.classList.remove('cslice-scroll-direction-down');
				body.classList.add('cslice-scroll-direction-up');
			}
		}

		// Hide header when scrolling down past header height
		// NOT at top OR scrolling up
		if (scrollTop > 80 && body.classList.contains('cslice-scroll-direction-down')) {
			body.classList.add('cslice-header-hide');
		} else {
			body.classList.remove('cslice-header-hide');
		}

		// Show after scrolling down
		// Changed from 500px
		if (scrollTop > 160) {
			body.classList.add('cslice-scrolled');
		} else {
			body.classList.remove('cslice-scrolled');
		}

		lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling

		ticking = false;
	}

	function throttleScroll() {
		if (!ticking) {
			window.requestAnimationFrame(() => {
				handleScroll();
				ticking = false;
			});
			ticking = true;
		}
	}

	window.addEventListener('scroll', throttleScroll);
});
